import { AppleIcon, InstagramIcon, SpotifyIcon, WavesIcon } from '@/components/Icons';

export function Profile({
  playerCardRef,
  trackListRef,
}: {
  playerCardRef: React.RefObject<HTMLDivElement>;
  trackListRef: React.RefObject<HTMLDivElement>;
}) {
  return (
    <section className="flex flex-col justify-center items-center">
      <div className="flex flex-col md:flex-row gap-8 items-center">
        <div className="flex justify-between lg:flex-row gap-24 items-center mt-12">
          <div className="w-full px-6 py-6">
            <h1 className="text-[1.5rem] font-normal leading-tight tracking-tight">Imogen Heap</h1>

            <p className="mt-4 text-[1.125rem] max-w-3xl leading-6">
              A 30-year career of self-produced music, four solo albums, Frou Frou, and collaborations with Taylor Swift, Deadmau5, and
              more.
            </p>

            <div className="mt-6 flex gap-6">
              <a href="https://music.apple.com/us/artist/imogen-heap/22873602" className="opacity-70 hover:opacity-100 transition-colors">
                <AppleIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a
                href="https://open.spotify.com/artist/6Xb4ezwoAQC4516kI89nWz?si=edsWHMlnT0qQwEWY1RL-ZQ"
                className="opacity-70 hover:opacity-100 transition-colors"
              >
                <SpotifyIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a href="https://www.instagram.com/imogenheap/" className="opacity-70 hover:opacity-100 transition-colors">
                <InstagramIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a href="https://tidal.com/browse/artist/34755" className="opacity-70 hover:opacity-100 transition-colors">
                <WavesIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
            </div>

            <div className="text-[0.8rem] mt-6 flex sm:flex-row gap-6">
              <button className="group text-left text-[0.75rem] font-normal">
                <span className="inline-flex text-[#48484B] items-center gap-2 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:text-jen-orange">
                  <span
                    className="underline"
                    onClick={() => {
                      if (playerCardRef?.current) {
                        playerCardRef.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    Read Bio
                  </span>
                </span>
              </button>

              <button className="group text-left text-[0.75rem] font-normal">
                <span className="inline-flex  text-[#48484B] items-center gap-2 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:text-jen-orange">
                  <span
                    className="underline"
                    onClick={() => {
                      if (trackListRef?.current) {
                        trackListRef.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    StyleFilter™ Generated Tracks
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
